import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import cx from 'classnames'
import log from 'loglevel'

import './style.scss'

export default class ProgressBar extends Component {
    static propTypes = {
        hasLabel: PropTypes.bool,
        message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        threshold: PropTypes.number,
        total: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    }

    static defaultProps = {
        hasLabel: true,
        message: null,
        threshold: 80,
    }

    renderLabel = () => {
        const { value, total, hasLabel } = this.props

        if (!hasLabel) return null

        const sideOffset = 2 // two percent (magic constant :) )

        const leftOffset = _.clamp(value / (total / 100), 0, 100) // in percent
        const rightOffset = 100 - leftOffset

        return (
            <div className={'label-container'}>
                <div className={'label-wrap'}>
                    <div className={'spacer'} style={{ width: `${_.clamp(leftOffset - sideOffset, 0, 100)}%` }} />
                    <div className={'label'}>{value}</div>
                    <div className={'spacer'} style={{ width: `${_.clamp(rightOffset - sideOffset, 0, 100)}%` }} />
                </div>
                <div className={'arrow'} style={{ left: `${_.clamp(leftOffset, sideOffset, 100 - sideOffset)}%` }} />
            </div>
        )
    }

    render() {
        const { value, total, threshold, message } = this.props

        if (total <= 0) {
            log.warn('Total in ProgressBar must be greater than 0')
            return null
        }

        const width = _.clamp(value / (total / 100), 0, 100) // in percent
        const isThreshold = threshold > 0 && width >= threshold

        return (
            <div className={cx('progress-bar', isThreshold && 'threshold')}>
                {this.renderLabel()}
                <div className={'bar'}>
                    <div className={'loaded'} style={{ width: `${width}%` }} />
                </div>
                {message && <div className={'message'}>{message}</div>}
            </div>
        )
    }
}
